<template>
  <div class="popularizeList">
    <div class="popularizeTab">
      <!-- <div class="popularItem active">随心推-短视频/图文带货</div> -->
      <div class="searchWapper" style="display: flex;">

        <a-page-header title="账户概览" sub-title="随心推-短视频/图文带货" />
        
  

      </div>

    </div>
    
    <div class="page-container"> 
      
      <div class="side-container">
          <div class="sidebar-table-wrapper">
            <div class="tab-sidebar">
              <div :class="item=='ALL'?'tab-sidebar-item selected':'tab-sidebar-item'" @click="changeItem('ALL')">
                <a-icon type="schedule" title="全部计划" :style="{ fontSize: '16px'}"/>
              </div>
              <div :class="item=='VIDEO'?'tab-sidebar-item selected':'tab-sidebar-item'" @click="changeItem('VIDEO')">
                <a-icon id="video-btn" type="play-square" title="短视频" :style="{ fontSize: '16px'}" />
              </div>
              <div :class="item=='PRODUCT'?'tab-sidebar-item selected':'tab-sidebar-item'" @click="changeItem('PRODUCT')">
                <a-icon id="product-btn" type="shopping" title="商品" :style="{ fontSize: '16px'}"/>
              </div>
              <div :class="item=='AWEME'?'tab-sidebar-item selected':'tab-sidebar-item'" @click="changeItem('AWEME')">
                <a-icon id="aweme-btn"  type="team" title="被投放号"  :style="{ fontSize: '16px'}"/>
              </div>

            </div>
          </div>
      </div>
      <div class="slibar-list" v-show="item == 'VIDEO'">
        <a-radio-group :value="videotype" @change="handleVideotypeChange" >
          <a-radio-button value="ALL" style="width: 70px;">
            全部
          </a-radio-button>
          <a-radio-button value="FOLLOW" style="width: 70px;"> 
            关注
          </a-radio-button>
          <a-radio-button value="DELIVERY_OK" style="width: 80px;">
            投放中
          </a-radio-button> 
        </a-radio-group>
        <div style="margin-top: 10px;">
          <a-range-picker  
            :ranges="{
                  '今日': [moment(), moment()],
                  '昨日': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  '本周': [moment().startOf('week'), moment()],
                  '上周': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                  '本月': [moment().startOf('month'), moment()],
                  '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }"   
            :value="video_range_date" @change="onVideoTimeChange" class="filterItem" :showToday="true"
            :placeholder="['开始时间', '结束时间']" /> 
        </div>
        <div class="item-list">
          <div class="bui-infinite-scroller-box">
            <a-input-search placeholder="请输入视频ID/标题" v-model="searchKey" enter-button @search="getVideoDataBySearch"  :loading="loading"/>
            <div style="margin-top: 10px;margin-bottom: 10px;display: flex;">
              <a-select v-model="sortby" style="width: 83%;"  @change="handleSortChange">
                <a-select-option value="launch_normal_count">按投放中数量降序</a-select-option>
                <a-select-option value="stat_cost" >按消耗金额降序</a-select-option>
                <a-select-option value="pay_order_amount" >按成交金额降序</a-select-option>
                <a-select-option value="prepay_and_pay_order_roi" >按支付ROI降序</a-select-option>
                <a-select-option value="pay_order_count" >按成交单数降序</a-select-option>
                <a-select-option value="click_cnt" >按点击次数降序</a-select-option>
                <a-select-option value="show_cnt" >按展示次数降序</a-select-option>
              </a-select>
              <a-button type="primary" icon="download" @click="exportExcel()" style="margin-left: 5px;"></a-button>
            </div>

            <div class="leftDiv">
            <a-spin :spinning="loading" tip="加载中...">
            <div class="shop-list" v-if="videolist.length>0">
              
              <div style="padding: 10px 0px;border-radius: 5px;margin-bottom: 15px;border: 1px solid #edf1fd;" v-for="opt in videolist" :key="opt.video_info_aweme_item_id" :value="opt.video_info_aweme_item_id" :class="opt.video_info_aweme_item_id==video_info_aweme_item_id?'selected':''">
                <div class='shop-account-item'>
                  <div class="shop-account-avatar" @click="changeVideo(opt.video_info_aweme_item_id)">
                      <img :src="opt.video_info_aweme_item_cover||'http://qc.zpfly.com/assets/img/empty2.png'" /> 
                  </div>  
                  <div class="shop-account-text">
                    <div class="byted-popover-wrapper">
                      <div class="ellipsis-text-component" @click="changeVideo(opt.video_info_aweme_item_id)" :title="opt.video_info_aweme_item_title">
                        <a-badge :count="opt.launch_normal_count" :number-style="{ backgroundColor: '#52c41a',fontSize:'12px',padding:'0px' }" v-if="opt.launch_normal_count" />
                        
                          <a-tooltip placement="top" :title="opt.video_info_aweme_item_title"> 
                                      {{opt.video_info_aweme_item_title||'-'}}
                          </a-tooltip>
                        </div>
                    </div>
                    <span class="shop-account-data"  @click="changeVideo(opt.video_info_aweme_item_id)" :title="opt.video_info_aweme_item_id">ID:{{opt.video_info_aweme_item_id}}</span>
                    
                  
                    <div style="display: flex;">  
                      <a-popover title="设置佣金"  placement="bottom" trigger="click" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <template slot="content">
                          <p>
                            <a-input-number placeholder="输入佣金比例" v-model="commission_rate" :min="1" :max="100" style="width: 100%;"/>
                          
                          </p>
                          <p style="font-size: 12px;color: #999;">（ 盈亏=成交订单金额*佣金-消耗）</p>
                          <p><a-button type="primary" icon="edit"  style="width: 100%;" @click="setCommisionRate(opt)">设置商品佣金</a-button></p>
                        </template>
                          <div class="commision_rate" @click="commission_rate = opt.commission_rate">佣金：{{opt.commission_rate||100}}% <a-icon type="edit"/></div>
                      </a-popover>
                      <a-icon type="heart"  theme="filled" @click="itemfollow(opt,'VIDEO')" style="position: absolute;right: 10px;top: 4px;color: red;" v-if="opt.follow"/>
                      <a-icon type="heart" @click="itemfollow(opt,'VIDEO')" style="position: absolute;right: 10px;top: 4px;" v-else/>
                    </div>
                
                  <!-- <a-popover title="设置备注"  placement="bottom" trigger="click" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                    <template slot="content">
                      <p>
                        <a-input placeholder="输入视频备注" v-model="video_remark" :min="1" :max="100" style="width: 100%;"/>
                      
                      </p>
                      <p><a-button type="primary" icon="edit"  style="width: 100%;" @click="setItemRemark(opt,'VIDEO')">设置视频备注</a-button></p>
                    </template>
                    <div class="commision_rate" style="color: rgb(250, 140, 22);" @click="video_remark = opt.remark">备注：{{opt.remark||'-'}} <a-icon type="edit"/></div>
                  </a-popover> -->



                  </div> 
                </div>
                <div class="statistic-wrapper"  @click="changeVideo(opt.video_info_aweme_item_id)">
                  <div class="statistic-item">
                    <p class="label">消耗金额</p>
                    <p class="value">{{opt.stat_cost}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">成交金额</p>
                    <p class="value">{{opt.pay_order_amount}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">支付ROI</p>
                    <p class="value profit" v-if="opt.prepay_and_pay_order_roi < 2">{{opt.prepay_and_pay_order_roi}}</p>
                    <p class="value loss" v-else>{{opt.prepay_and_pay_order_roi}}</p>
                    
                  </div>
                  <div class="statistic-item">
                    <p class="label">成交单数</p>
                    <p class="value">{{opt.pay_order_count}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">点击次数</p>
                    <p class="value">{{opt.click_cnt}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">展示次数</p>
                    <p class="value">{{opt.show_cnt}}</p>
                  </div>
                </div>
              </div> 



              
            </div>
            <div class="shop-list" v-else>
              <a-empty :image="simpleImage" />
            </div>
            </a-spin>
          </div>
          </div>
        </div>
      </div>





      <div class="slibar-list" v-show="item == 'PRODUCT'">
        <a-radio-group :value="producttype" @change="handleProductChange" >
          <a-radio-button value="ALL" style="width: 70px;">
            全部
          </a-radio-button>
          <a-radio-button value="FOLLOW" style="width: 70px;"> 
            关注
          </a-radio-button>
          <a-radio-button value="DELIVERY_OK" style="width: 80px;">
            投放中
          </a-radio-button> 
        </a-radio-group>
        <div style="margin-top: 10px;">
          <a-range-picker  
            :ranges="{
                  '今日': [moment(), moment()],
                  '昨日': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                  '本周': [moment().startOf('week'), moment()],
                  '上周': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                  '本月': [moment().startOf('month'), moment()],
                  '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
                }"   
            :value="video_range_date" @change="onVideoTimeChange" class="filterItem" :showToday="true"
            :placeholder="['开始时间', '结束时间']" /> 
        </div>
        <div class="item-list">
          <div class="bui-infinite-scroller-box">
            <a-input-search placeholder="请输入被商品ID/标题" v-model="searchKey" enter-button @search="getProductBySearch"  :loading="loading"/>
            <div style="margin-top: 10px;margin-bottom: 10px;display: flex;">
              <a-select v-model="sortby" style="width: 83%;"  @change="handleSortChange">
                <a-select-option value="launch_normal_count">按投放中数量降序</a-select-option>
                <a-select-option value="stat_cost" >按消耗金额降序</a-select-option>
                <a-select-option value="pay_order_amount" >按成交金额降序</a-select-option>
                <a-select-option value="prepay_and_pay_order_roi" >按支付ROI降序</a-select-option>
                <a-select-option value="pay_order_count" >按成交单数降序</a-select-option>
                <a-select-option value="click_cnt" >按点击次数降序</a-select-option>
                <a-select-option value="show_cnt" >按展示次数降序</a-select-option>
              </a-select>
              <a-button type="primary" icon="download" @click="exportProductExcel()" style="margin-left: 5px;"></a-button>
            </div>

            <div class="leftDiv">
            <a-spin :spinning="loading" tip="加载中...">
            <div class="shop-list" v-if="productList.length>0">
              
              <div style="padding: 10px 0px;border-radius: 5px;margin-bottom: 15px;border: 1px solid #edf1fd;" v-for="opt in productList" :key="opt.product_info_id" :value="opt.product_info_id" :class="opt.product_info_id==product_id?'selected':''">
                <div class='shop-account-item'>
                  <div class="shop-account-avatar" @click="changeProduct(opt.product_info_id)">
                      <img style="height: 50px;" :src="opt.product_info_img||'http://qc.zpfly.com/assets/img/empty2.png'" /> 
                  </div>  
                  <div class="shop-account-text">
                    <div class="byted-popover-wrapper">
                      <div class="ellipsis-text-component" @click="changeProduct(opt.product_info_id)" :title="opt.product_info_name">
                        <a-badge :count="opt.launch_normal_count" :number-style="{ backgroundColor: '#52c41a',fontSize:'12px',padding:'0px' }" v-if="opt.launch_normal_count" />
                        
                          <a-tooltip placement="top" :title="opt.product_info_name"> 
                                      {{opt.product_info_name||'-'}}
                          </a-tooltip>
                        </div>
                    </div>
                    <span class="shop-account-data"  @click="changeProduct(opt.product_info_id)" :title="opt.product_info_id">ID:{{opt.product_info_id}}</span>
                    
                    <div style="display: flex;">  
                      <a-icon type="heart"  theme="filled" @click="itemfollow(opt,'PRODUCT')" style="position: absolute;right: 10px;top: 4px;color: red;" v-if="opt.follow"/>
                      <a-icon type="heart" @click="itemfollow(opt,'PRODUCT')" style="position: absolute;right: 10px;top: 4px;" v-else/>
                    </div>  
                  </div> 
                </div>
                <div class="statistic-wrapper"  @click="changeProduct(opt.product_info_id)" >
                  <div class="statistic-item">
                    <p class="label">消耗金额</p>
                    <p class="value">{{opt.stat_cost}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">成交金额</p>
                    <p class="value">{{opt.pay_order_amount}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">支付ROI</p>
                    <p class="value profit" v-if="opt.prepay_and_pay_order_roi < 2">{{opt.prepay_and_pay_order_roi}}</p>
                    <p class="value loss" v-else>{{opt.prepay_and_pay_order_roi}}</p>
                    
                  </div>
                  <div class="statistic-item">
                    <p class="label">成交单数</p>
                    <p class="value">{{opt.pay_order_count}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">点击次数</p>
                    <p class="value">{{opt.click_cnt}}</p>
                  </div>
                  <div class="statistic-item">
                    <p class="label">展示次数</p>
                    <p class="value">{{opt.show_cnt}}</p>
                  </div>
                </div>
              </div>  
            </div>
            <div class="shop-list" v-else>
              <a-empty :image="simpleImage" />
            </div>
            </a-spin>
          </div>
          </div>
        </div>
      </div>
 
      <div class="slibar-list" v-show="item == 'AWEME'">
          <a-radio-group :value="videotype" @change="handleVideotypeChange" >
            <a-radio-button value="ALL" style="width: 70px;">
              全部
            </a-radio-button>
            <a-radio-button value="FOLLOW" style="width: 70px;"> 
              关注
            </a-radio-button>
            <a-radio-button value="DELIVERY_OK" style="width: 80px;">
              投放中
            </a-radio-button> 
          </a-radio-group>
          
          <div style="margin-top: 10px;">
            <a-range-picker
              :ranges="{
                '今日': [moment(), moment()],
                '昨日': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                '本周': [moment().startOf('week'), moment()],
                '上周': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
                '本月': [moment().startOf('month'), moment()],
                '上月': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
              }"  
              :value="video_range_date" @change="onVideoTimeChange" class="filterItem" :showToday="true"
              :placeholder="['开始时间', '结束时间']" /> 
          </div>

          <div class="bui-infinite-scroller-box" style="margin-top: 10px;" >
            <a-input-search placeholder="请输入被投放号ID/昵称" v-model="searchKey"  enter-button @search="getNearDataBySearch"  :loading="loading"/>
            <div style="margin-top: 10px;margin-bottom: 10px;display: flex;">
              <a-select v-model="sortby" style="width: 83%;"  @change="handleSortChange">
                <a-select-option value="launch_normal_count">按投放中数量降序</a-select-option>
                <a-select-option value="stat_cost" >按消耗金额降序</a-select-option>
                <a-select-option value="pay_order_amount" >按成交金额降序</a-select-option>
                <a-select-option value="prepay_and_pay_order_roi" >按支付ROI降序</a-select-option>
                <a-select-option value="pay_order_count" >按成交单数降序</a-select-option>
                <a-select-option value="click_cnt" >按点击次数降序</a-select-option>
                <a-select-option value="show_cnt" >按展示次数降序</a-select-option>
              </a-select>
              <a-button type="primary" icon="download" @click="exportExcel()" style="margin-left: 5px;"></a-button>
            </div>
            <div class="leftAwemeDiv" > 
            <a-spin :spinning="loading" tip="加载中..."> 
              <div  class="shop-list" style="margin-top: 10px;"  v-if="awemeList.length>0">
                <div style="padding: 10px 0px;border-radius: 5px;margin-bottom: 15px;border: 1px solid #edf1fd;" v-for="opt in awemeList" :key="opt.aweme_info_aweme_id" :value="opt.aweme_info_aweme_id" :class="opt.aweme_info_aweme_id==aweme_info_aweme_id?'selected':''">
                  <div class='shop-account-item' >
                    <div class="shop-account-avatar" @click="changeAweme(opt.aweme_info_aweme_id)" style="border-radius: 50%;">
                        <img :src="opt.aweme_info_aweme_avatar||'http://qc.zpfly.com/assets/img/empty2.png'" style="height: 50px;border-radius: 50%;"/> 
                    </div>  
                    <div class="shop-account-text">
                      <div class="byted-popover-wrapper">
                        <div class="ellipsis-text-component" @click="changeAweme(opt.aweme_info_aweme_id)" :title="opt.aweme_info_aweme_name">
                          <a-badge :count="opt.launch_normal_count" :number-style="{ backgroundColor: '#52c41a',fontSize:'12px',padding:'0px' }" v-if="opt.launch_normal_count" />
                          
                            <a-tooltip placement="top" :title="opt.aweme_info_aweme_name"> 
                                        {{opt.aweme_info_aweme_name||'-'}}
                            </a-tooltip>
                            <a-icon type="heart"  theme="filled" @click="itemfollow(opt,'AWEME')" style="position: absolute;right: 10px;top: 13px;color: red;" v-if="opt.follow"/>
                            <a-icon type="heart" @click="itemfollow(opt,'AWEME')" style="position: absolute;right: 10px;top: 13px;" v-else/>
                      
                          </div>
                      </div>
                      <span class="shop-account-data"  @click="changeAweme(opt.aweme_info_aweme_id)" :title="opt.aweme_info_aweme_id">ID:{{opt.aweme_info_aweme_id}}</span>
                      
                    
                      <a-popover title="设置备注"  placement="bottom" trigger="click" :getPopupContainer="triggerNode => {return triggerNode.parentNode || document.body;}">
                        <template slot="content">
                          <p>
                            <a-input placeholder="输入抖音号备注" v-model="video_remark" :min="1" :max="100" style="width: 100%;"/>
                          </p>
                          <p><a-button type="primary" icon="edit"  style="width: 100%;margin-top: 5px;" @click="setItemRemark(opt,'AWEME')">设置抖音号备注</a-button></p>
                        </template>
                        <div class="commision_rate" style="color: rgb(250, 140, 22);" @click="video_remark = opt.remark">备注：{{opt.remark||'-'}} <a-icon type="edit"/></div>
                      </a-popover>



                    </div> 
                  </div>
                  <div class="statistic-wrapper"  @click="changeAweme(opt.aweme_info_aweme_id)" v-if="false">
                    <div class="statistic-item">
                      <p class="label">消耗金额</p>
                      <p class="value">{{opt.stat_cost}}</p>
                    </div>
                    <div class="statistic-item">
                      <p class="label">成交金额</p>
                      <p class="value">{{opt.pay_order_amount}}</p>
                    </div>
                    <div class="statistic-item">
                      <p class="label">支付ROI</p>
                      <p class="value profit" v-if="opt.prepay_and_pay_order_roi < 2">{{opt.prepay_and_pay_order_roi}}</p>
                      <p class="value loss" v-else>{{opt.prepay_and_pay_order_roi}}</p>
                      
                    </div>
                    <div class="statistic-item">
                      <p class="label">成交单数</p>
                      <p class="value">{{opt.pay_order_count}}</p>
                    </div>
                    <div class="statistic-item">
                      <p class="label">点击次数</p>
                      <p class="value">{{opt.click_cnt}}</p>
                    </div>
                    <div class="statistic-item">
                      <p class="label">展示次数</p>
                      <p class="value">{{opt.show_cnt}}</p>
                    </div>
                  </div>
                </div> 
              </div>
              <div class="shop-list" v-else>
                <a-empty :image="simpleImage" />
              </div> 
              </a-spin>
            </div>
          </div>
      </div>
      <div :class="item=='ALL'?'contentWapper':'contentWapper contentWapperOther'">
        <div class="filterOperate">
          
        <AwemeList :dataSource="dataSource" action="setAdvertiserId"  :advertiser_id="advertiser_id"  @getAdvertiserId="getAdvertiserId"
        v-if="dataSource.length > 0" />
        <a-tag color="red" v-if="order.status" style="margin-left: 15px;width: 510px;height: 32px;line-height: 32px;text-align: left;padding-left: 15px;">
          
          <a-icon type="exclamation-circle" /> 当前户到期时间为：<b style="margin-right: 10px;">[ {{order.endtime}} ]</b>  
          
          <span v-if="order.c>0">当前剩余时间仅剩 <b>{{order.c}}</b> 天 </span>
          <span v-else>当前已过期 <b>{{-order.c}}</b> 天 </span>
         
          <b style="margin-left: 20px;color: #1890ff;cursor: pointer;"  @click="payAccount">[ 立即续费 ]</b>
        </a-tag>

        <a-tag color="green" v-else style="margin-left: 15px;width: 150px;height: 32px;line-height: 32px;text-align: left;padding-left: 15px;font-weight: bold;">
          <a-icon type="rise" /> 数据更新频率：30S
        </a-tag>

        </div>
        <div class="contentBox">
          <div class="tabContentBox">
            <ShowTemplate
              ref="adlist"
              :video_info_aweme_item_id = "video_info_aweme_item_id"
              :product_id = "product_id"
              :aweme_info_aweme_id = "aweme_info_aweme_id"
              :advertiser_id="advertiser_id" 
              :marketing_goal="marketing_goal"
              @getVidioItem = "getVidioItem"
              @getAwemeItem = "getAwemeItem"
            />
          </div>
        </div>
      </div>
    </div>


    <a-modal
      v-if="order.status"
      :visible="dqvisible"
      :footer="null"
      width="400px"
      @cancel="dqvisible=false"
    >
      <div class="dqtitle">会员到期提醒</div>

      <div class="dqtag"> 
        <span v-if="order.c>0">温馨提示：当前剩余时间仅剩 <b style="color: #fe346e;">{{order.c}}</b> 天 </span>
        <span v-else>温馨提示：您当前授权户已过期 <b style="color: #fe346e;">{{-order.c}}</b> 天 </span>
        ,账户到期后将会影响您计划创建、监控等功能，请您及时续费！
      </div>

      <div class="dqbtn">
        <a-button style="background: #fe346e;color: #fff;border: none;" size="large" @click="payAccount">在线续费</a-button>
        <div  class="dqtag">
          <p><img src="@images/kefu2.jpg" style="width:250px;margin: 0 auto;"> </p>
          <p><a-icon type="question-circle" /> 添加客服微信，享受会员专属折扣</p>
        </div>
      </div>
    </a-modal>

    <feature-guide
      :steps="guideSteps"
      guide-key="video_feature_2025"
      :delay="800" 
      @complete="onGuideComplete"
    />

  </div>
</template>
<script>
import { ShowTemplate } from './components';
import { qcApi, requestHttp } from '@utils/index';
import { Modal } from 'ant-design-vue'; 
import { Empty } from 'ant-design-vue';
import awemeList from '../batchCreatePlan/components/awemeList.vue';
import moment from 'moment';  
import { FeatureGuide } from '@components';

export default {
  name: 'popularizeList',
  props: {},

  data() {
    return {
      guideSteps: [
        {
          element: '#video-btn',
          popover: {
            title: '视频维度',
            description: '点此可以查看视频维度下的计划',
            position: 'bottom'
          }
        },
        {
          element: '#product-btn',
          popover: {
            title: '商品维度',
            description: '点此可以查看商品维度下的计划',
            position: 'bottom'
          }
        },
        {
          element: '#aweme-btn',
          popover: {
            title: '被投放号维度',
            description: '点此可以查看被投放号维度下的计划',
            position: 'bottom'
          }
        }
      ],
      advertiserList: [],
      advertiser_id: '',
      range_date: [],
      dataSource:[],
      marketing_goal: 'VIDEO_PROM_GOODS',
      item:'ALL',
      videotype:'ALL',
      videolist:[],
      video_info_aweme_item_id:'',
      video_all_count:0,
      video_tfz_count:0,
      simpleImage:Empty.PRESENTED_IMAGE_SIMPLE,
      product_id:'',
      aweme_info_aweme_id:'',
      awemeList:[],
      searchKey:'',
      awemetype:'ALL',
      aweme_all_count:0,
      aweme_tfz_count:0,
      page:1,
      loading:false,
      commission_rate:'',
      productList:[],
      product_info_id:'',
      product_all_count:0,
      product_tfz_count:0,
      producttype:'ALL',
      order:{
        status:false,
        endtime:'',
        c:0,
      },
      video_remark:'',
      dqvisible:true,
      video_range_date:[],
      aweme_range_date:[],
      sortby:'launch_normal_count'
    };
  },

  components: {
    AwemeList: awemeList,
    ShowTemplate,
    FeatureGuide,
  },

  watch: {
  },
  async mounted() {    
    await this.getAdvertiserList();
    // document.getElementsByClassName('leftDiv')[0].addEventListener('scroll', this.lazyLoading) // 滚动到底部，再加载的处理事件
    // document.getElementsByClassName('leftAwemeDiv')[0].addEventListener('scroll', this.lazyAwemeLoading) // 滚动到底部，再加载的处理事件
  },
  methods: {
    moment,
    onGuideComplete() {
      // this.$message.success('新功能引导已完成！')
      // 可以在这里执行引导完成后的逻辑
    },
    // 如果需要手动重置引导（例如功能更新后）
    resetGuide() {
      this.$refs.featureGuide.resetGuide()
    },
    getVidioItem(item){
      this.video_info_aweme_item_id = item.video_info_aweme_item_id+''
      this.changeItem('VIDEO')
    },
    getAwemeItem(item){
      this.aweme_info_aweme_id = item.aweme_info_aweme_id+''
      this.changeItem('AWEME')
    },
    exportExcel(){
      let start_date = this.video_range_date[0] ? this.video_range_date[0] : ''
      let end_date = this.video_range_date[1] ? this.video_range_date[1] : ''
      const strUrl  = "http://qc.zpfly.com/api/sxt/exportVideoExcel?marketing_goal="+this.marketing_goal+"&advertiser_id="+this.advertiser_id+'&start_date='+start_date+'&end_date='+end_date+'&video_info_aweme_item_id='+this.video_info_aweme_item_id+'&token='+localStorage.getItem('token')+'&type='+this.item
      console.log(strUrl)
      Modal.confirm({
        title: '提醒',
        content: '确认是否按照当前查询条件导出数据？',
        onOk: () => {
          window.open(strUrl)
        },
      }); 
    },
    handleSortChange(e) {
      this.sortby = e 
      this.changeItem(this.item)
    },
    onVideoTimeChange(e, date){
      this.video_range_date = date;
      this.changeItem(this.item)
    },
    onAwemeTimeChange(e, date){
      this.aweme_range_date = date;
      console.log(this.aweme_range_date)
      this.changeItem('AWEME')
    },
    async setCommisionRate(e){ 
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_PRODUCT_COMMISSION}`,
        method: 'POST',
        params: {
          advertiser_id: e.advertiser_id,
          aweme_id:e.aweme_info_aweme_id,
          aweme_item_id: e.video_info_aweme_item_id, 
          commission_rate: this.commission_rate,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg)
      this.page = 1
      this.videolist = []
      this.getVideoData()
      this.$refs.adlist.getData()
    },
    async setItemRemark(e,type){ 
      let params = {
          advertiser_id: e.advertiser_id,
          aweme_id:e.aweme_info_aweme_id,
          type:type,
          remark: this.video_remark,
      }
      if(type=='VIDEO'){
        params.aweme_item_id = e.video_info_aweme_item_id
      }
      if(type=='PRODUCT'){
        params.product_id = e.product_info_id
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_ITEM_REMARK}`,
        method: 'POST',
        params: params,
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg)
      this.page = 1
      if(type=='VIDEO'){
        this.videolist = []
        this.getVideoData()
      }else if(type=='PRODUCT'){
        this.productList = []
        this.getProductData()
      }else if(type=='AWEME'){
        this.awemeList = []
        this.getNearData()
      }
      this.$refs.adlist.getData()
    },
    async itemfollow(e,type){
      let params =  {
          advertiser_id: e.advertiser_id,
          aweme_id:e.aweme_info_aweme_id,
          type:type,
      }
      if(type=='VIDEO'){
        params.aweme_item_id = e.video_info_aweme_item_id
      }
      if(type=='PRODUCT'){
        params.product_id = e.product_info_id
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_ADD_ITEM_FOLLOW}`,
        method: 'POST',
        params:params,
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.$message.success(msg)
      this.page = 1
      if(type=='VIDEO'){
        this.videolist = []
        this.getVideoData()
      }else if(type=='PRODUCT'){
        this.productList = []
        this.getProductData()
      }else if(type=='AWEME'){
        this.awemeList = []
        this.getNearData()
      }
      this.$refs.adlist.getData()
    },
    lazyLoading(){
        const target = document.getElementsByClassName('leftDiv')[0]
        const scrollTop = target.scrollTop // 滚动条滚动时，距离顶部的距离
        const windowHeight = target.clientHeight // 可视区的高度
        const scrollHeight = target.scrollHeight // 滚动条的总高度 
        if (scrollTop + windowHeight === scrollHeight) {
            // 滚动到底部，逻辑代码
            this.page++
            this.getVideoData()
            console.log('滚动到了底部',this.page)
        } 
    },
    lazyAwemeLoading(){
        const target = document.getElementsByClassName('leftAwemeDiv')[0]
        const scrollTop = target.scrollTop // 滚动条滚动时，距离顶部的距离
        const windowHeight = target.clientHeight // 可视区的高度
        const scrollHeight = target.scrollHeight // 滚动条的总高度 
        if (scrollTop + windowHeight === scrollHeight) {
            // 滚动到底部，逻辑代码
            this.page++
            this.getNearData()
            console.log('滚动到了底部',this.page)
        } 
    },
    changeVideo(e){
      this.searchKey = ''
      this.video_info_aweme_item_id = e
    },
    changeProduct(e){
      this.searchKey = ''
      this.product_id = e
    },
    changeAweme(e){
      this.searchKey = ''
      this.aweme_info_aweme_id = e
    },
    handleVideotypeChange(e){
      console.log(e) 
      this.videotype = e.target.value
      this.changeItem(this.item)
    },
    handleAwemetypeChange(e){
      console.log(e)
      this.page = 1
      this.awemeList = []
      this.awemetype = e.target.value
      this.getNearData()
    },
    handleProductChange(e){
      this.page = 1
      this.productList = []
      this.producttype = e.target.value
      this.getProductData()
    },
    changeItem(item){
      this.page = 1
      console.log('获取到的',this.advertiser_id)
      this.item = item
      this.searchKey = ''
      if(item == 'ALL'){
        this.video_range_date = []
        this.aweme_range_date = []
        this.video_info_aweme_item_id = ''
        this.product_id = ''
        this.aweme_info_aweme_id = ''
      }else if(item == 'VIDEO'){
        // this.aweme_range_date = []
        this.product_id = ''
        this.aweme_info_aweme_id = ''
        this.videolist = []
        this.getVideoData()
      }else if(item == 'PRODUCT'){
        this.video_range_date = []
        this.aweme_range_date = []
        this.video_info_aweme_item_id = ''
        this.aweme_info_aweme_id = ''
        this.productList = []
        this.getProductData()
      }else if(item == 'AWEME'){
        // this.video_range_date = []
        this.product_id = ''
        this.video_info_aweme_item_id = ''
        this.awemeList = []
        this.getNearData()
      }
    },
    getNearDataBySearch(){
      this.awemeList = []
      this.page = 1
      this.getNearData()
    },
    getProductBySearch(){
      this.productList = []
      this.page = 1
      this.getProductData()
    },
    async getNearData() {
      console.log(1111) 
      this.loading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_VIDEO_LIVE_REPORT}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal:'VIDEO_PROM_GOODS',
          videotype : this.videotype,
          page:this.page,
          pagesize:20,
          searchKey:this.searchKey,
          start_date: this.video_range_date[0] ? this.video_range_date[0] : '',
          end_date: this.video_range_date[1] ? this.video_range_date[1] : '',
          sortby:this.sortby,
          group:'aweme_info_aweme_id'
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.awemeList = this.awemeList.concat(data.list)
      if(data.list.length>0){ 
        this.aweme_info_aweme_id = this.aweme_info_aweme_id?this.aweme_info_aweme_id:data.list[0].aweme_info_aweme_id
      }
    },
    getVideoDataBySearch(){
      this.page = 1
      this.videolist = []
      this.getVideoData()
    },
    async getVideoData() {
      console.log(3333)
      this.loading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.SXT_VIDEO_LIVE_REPORT}`,
        method: 'POST',
        params: {
          advertiser_id: this.advertiser_id,
          marketing_goal:'VIDEO_PROM_GOODS',
          videotype : this.videotype,
          page:this.page,
          pagesize:20,
          searchKey:this.searchKey,
          start_date: this.video_range_date[0] ? this.video_range_date[0] : '',
          end_date: this.video_range_date[1] ? this.video_range_date[1] : '',
          sortby:this.sortby,
          group:'video_info_aweme_item_id'
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return;
      this.videolist = this.videolist.concat(data.list)
      if(data.list.length>0){ 
        this.video_info_aweme_item_id = this.video_info_aweme_item_id?this.video_info_aweme_item_id:data.list[0].video_info_aweme_item_id
      }
      // else{
      //   this.video_info_aweme_item_id = ''
      // }
    },
    getAdvertiserId(advertiser_id) {
      console.log('子组件传回的值', advertiser_id)
      localStorage.setItem('sxt_advertiser_id', advertiser_id);
      this.getEndtime(advertiser_id)
      this.page = 1
      this.videolist = []
      this.awemeList = []  
      this.productList = []  
      this.advertiser_id = advertiser_id
      if(this.item == 'VIDEO'){
        this.getVideoData()
      }else if(this.item == 'AWEME'){
        this.getNearData()
      }else if(this.item == 'PRODUCT'){
        this.getProductData()
      }
    },
    async getEndtime(advertiser_id) { 
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ALL_ADVERTISER}`,
        method: 'POST',
        params: {
          type: 'SXT',
          status: '',
          advertiser_id:advertiser_id
        },
      }); 
      if (code == 0) {
        // this.$message.error(msg);
        return;
      }
      console.log(data);
      if (!data) return; 
      let c = data.list[0].c
      console.log('DDDDDDDDD',data.list[0].order_list[0].end_time)
      if(data.list[0].order_list.length>0){ 
        let endtime = data.list[0].order_list[0].end_time
        if(c < 5){
          this.order.status = true 
        }else{
          this.order.status = false
        }
        this.order.c = c
        this.order.endtime = endtime
      }
      this.dqvisible = true
    },
    payAccount() {
      const strUrl = "https://fuwu.oceanengine.com/product/7184717543884472353"
      let a = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.target = "_blank";
      a.href = strUrl;
      a.click();
      document.body.removeChild(a);
    }, 
    async getProductData(){
      this.loading = true
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_PRODUCT_LIST_NEW}`,
        method: 'POST',
        params: { 
          advertiser_id: this.advertiser_id,
          marketing_goal:'VIDEO_PROM_GOODS',
          videotype: this.producttype,
          page:this.page,
          pagesize:20,
          searchKey:this.searchKey,
          start_date: this.video_range_date[0] ? this.video_range_date[0] : '',
          end_date: this.video_range_date[1] ? this.video_range_date[1] : '',
          sortby:this.sortby,
          group:'video_info_aweme_item_id'
        },
      });
      this.loading = false;
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      console.log('获取到的商品列表',data);
      if (!data) return;
      this.productList = this.productList.concat(data.list) 
      this.product_all_count = data.count
      this.product_tfz_count = data.tfz_count
      if(data.list.length>0){ 
        this.product_id = this.product_id?this.product_id:data.list[0].product_info_id
      }
    },
    async getAdvertiserList() {
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.GET_ADVERTISER_LIST}`,
        method: 'POST',
        params: {
          type: 'SXT',
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      if (!data) return;
      this.advertiserList = data.list;
      this.dataSource = data.list
      if (data.list.length == 0) {
        Modal.confirm({
          title: '提醒',
          content: '您尚未授权随心推账户，是否前往授权？',
          onOk: () => {
            this.$router.replace('/sxt_account');
          },
        });
      } else {
        if(localStorage.getItem('sxt_advertiser_id')){
          this.advertiser_id = localStorage.getItem('sxt_advertiser_id')
        }else{
          this.advertiser_id = data.list[0].advertiser_id; 
        } 
        this.getEndtime(this.advertiser_id)
      }
    },
    handleChange(value) {
      console.log(`selected选中 ${value}`);
      this.advertiser_id = value;

    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },  
    changeTab(type) {
      this.selectMenuTab = type;
    },
  },
};
</script>

<style lang="less" scoped>
.page-container {
  display: flex;
} 
.leftDiv{
  height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
}
.leftDiv::-webkit-scrollbar,.leftAwemeDiv::-webkit-scrollbar{
  display: none; /* WebKit */
}
.leftAwemeDiv{
  height: 100vh;
  overflow-y: auto;
  scrollbar-width: none;
}
.scroll-box{
  height: 200px;
  overflow-y: auto;
}
.shop-account-item{
  align-items: center;
  border-radius: 4px;
  display: flex;
  height: 80px;
  justify-content: flex-start;
  padding: 16px;
  position: relative;
} 
.item-list{
  margin-top: 10px;
}
.shop-account-item.selected,.shop-list .selected{
    background: #edf1fd;
    position: relative;
}
.shop-list{
  cursor: pointer;
}
.byted-avatar-img {
  background: transparent;
}
.byted-avatar-square {
  border-radius: 6px;
}
.byted-avatar-md {
  font-size: 24px;
  height: 48px;
  line-height: 48px;
  width: 48px;
}
.shop-account-avatar {
  border: 1px solid #ebebeb;
color: #fff;
overflow: hidden;
position: relative;
text-align: center;
border-radius: 3px;
}
.byted-popover-wrapper{
  text-align: left;
}
.ellipsis-text-component{
  width: 124px; 
  font-size: 12px;
  font-weight: 600;
  color: rgb(51, 51, 51);
  cursor: pointer;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  -moz-box-orient: vertical;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
  line-height: 16px;
}
.commision_rate{
  width: 124px; 
  font-size: 12px;
  font-weight: bold;
  color: green;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  display: -moz-box;
  -moz-line-clamp: 3;
  -moz-box-orient: vertical;
  overflow-wrap: break-word;
  word-break: break-all;
  white-space: normal;
  overflow: hidden;
}
.shop-account-avatar > img {
  display: block;
  height: 70px;
  width: 50px;
  border-radius: 3px;
}
.shop-account-text {
  margin-left: 9px;
  width: 130px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.shop-account-data{
  color: #999;
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  margin-top: 8px;
}
.shop-account-item.selected::before,.shop-list .selected::before {
  background-color: #1890ff;
  border-radius: 4px;
  content: "";
  display: block;
  height: 24px;
  left: 0;
  margin-top: -12px;
  position: absolute;
  top: 50%;
  width: 4px;
}
.slibar-list{
  background-color: #fff;
  border-radius: 8px 0 0;
  border-right: 1px solid #e5e5e5;
  overflow-y: auto;
  padding: 16px;
  transition: width .15s ease-in-out;
  width: 300px;
}
.mainContent{
  background: none !important;
}
.ant-page-header{
  padding: 0px 0px 10px 0px;
}
.sidebar-table-wrapper{
  display: flex;
  .tab-sidebar{
    display: flex;
    flex-direction: column;
    width: 44px;
    .tab-sidebar-item {
      cursor: pointer;
      height: 54px;
      padding: 17px 13px;
    }
    .tab-sidebar-item.selected {
      background-color: #fff;
      border-radius: 12px 0 0 12px;
    }
  }
}
.popularizeTab {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .popularItem {
    margin-right: 10px;
    padding: 10px 20px;
    text-align: center;
    border-radius: 5px;
    float: left;
    margin-right: 10px;
    color: #fff;
    cursor: pointer;
  }
  .active {
    background-color: #1890ff;
  }
}

.contentWapper {
  position: relative;
  padding: 20px;
  width:-webkit-calc(100% - 45px); 
  width:-moz-calc(100% - 45px); 
  width:calc(100% - 45px); 
  background-color: #fff;
  .filterOperate {
    display: flex;
    // align-items: center;
    justify-content: flex-start;
  }
  .filterItem {
    margin-right: 15px;
  }
}
.contentWapperOther{
  width:-webkit-calc(100% - 300px); 
  width:-moz-calc(100% - 300px); 
  width:calc(100% - 300px); 
}
.contentBox {
  display: flex;
  align-items: flex-start;
  justify-items: flex-start;
  list-style-type: none;
  margin-top: 10px;
  .tabMenue {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background: #f0f2f5;
    padding: 0px;
    border-radius: 8px;
    .tabIcon {
      height: 40px;
      width: 40px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      background: #f0f2f5;
      border-radius: 8px;
      &.selected {
        background: #fff;
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
  }
}
.tabContentBox {
  width: 100%;
}
.dqtitle{
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #fe346e;
  margin-bottom: 20px
}
.dqtag{
  font-size: 14px;
  color: #333;
  text-align: center;
}
.dqbtn{
  margin-top: 20px;
  button{
    margin-bottom: 10px;
    width:100%
  }
}
.page-container {
  padding-bottom:70px !important;
}

.statistic-wrapper {
 margin-top:10px;
 display:grid;
 grid-template-columns:repeat(3,1fr);
 grid-gap:10px
}
.statistic-wrapper .statistic-item {
 display:flex;
 flex-direction:column;
 align-items:center;
 justify-content:center;
 line-height:17px
}
.statistic-wrapper .statistic-item .label {
 font-size:12px;
 color:#999
}
.statistic-wrapper .statistic-item .value {
 margin-top:4px;
 font-size:14px;
 font-weight:500;
 line-height:17px
}
.statistic-wrapper .statistic-item .value.profit {
 color:#f00000;
 font-weight: bold;
}
.statistic-wrapper .statistic-item .value.loss {
 color:#00a511;
 font-weight: bold;
}
</style>
